import {URLS} from "./app-urls";
import {AbstractService, Expands, Filters} from "./abstract-service";
import {ImportPo} from "../models/basic/import-po";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";
import {AxiosResponse} from "axios";

export type ImportPoMonitoringFilter = Filters & {
    years?: string,
    client?: string,
};

export class ImportPoMonitoringService extends AbstractService<ImportPo> {

    constructor() {
        super(URLS.IMPORT_PO);
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        if (processedFilter?.client === "0") {
            delete processedFilter.client;
        }

        if(processedFilter.years) {
            if(!processedFilter.years) {
                delete processedFilter.years;
            }
        }

        return processedFilter;
    }

    async listYears(): Promise<AxiosResponse<{ years: number[] }>> {
        const path = `${this.path}list_years/`;
        return await trackPromise(Api.get(path));
    }

}
